module.exports = __webpack_public_path__ + "static/It-Takes-A-Titan-Campaign-Update-1-800x500-01dc6c2fcbc8fee9f9f95c141ba0cc2e.jpg";